var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M60.5 120C93.6371 120 120.5 93.1371 120.5 60C120.5 26.8629 93.6371 0 60.5 0C27.3629 0 0.5 26.8629 0.5 60C0.5 93.1371 27.3629 120 60.5 120Z",
    fill: "#2DD504"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.5 110C88.1142 110 110.5 87.6142 110.5 60C110.5 32.3858 88.1142 10 60.5 10C32.8858 10 10.5 32.3858 10.5 60C10.5 87.6142 32.8858 110 60.5 110Z",
    fill: "#2DD504"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 100C82.5914 100 100.5 82.0914 100.5 60C100.5 37.9086 82.5914 20 60.5 20C38.4086 20 20.5 37.9086 20.5 60C20.5 82.0914 38.4086 100 60.5 100Z",
    fill: "#2DD504"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0946 70C56.3294 70.0038 55.5642 69.7288 54.9744 69.1631L47.3863 61.8793C46.2146 60.748 46.2026 58.9116 47.3624 57.7725C48.5221 56.6296 50.4152 56.618 51.5908 57.7454L57.0508 62.9835L70.3818 49.865C71.5455 48.7221 73.4385 48.7105 74.6102 49.8379C75.7859 50.9692 75.7978 52.8095 74.6381 53.9447L59.2029 69.136C58.621 69.7094 57.8598 69.9961 57.0946 70Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.90a0189bdfea33dd996116935f398eff.svg";
export { ForwardRef as ReactComponent };